import Enums from 'utils/EnumsManager';
import {
  ADD_TRIGGER,
  REMOVE_TRIGGER,
  RESET_TRIGGER,
  SET_TRIGGER_OBJECT_KEY,
  ADD_TRIGGER_ACTION,
  UPDATE_TRIGGER_ACTION_FILTER_VALUE,
  REMOVE_SESSION_FILTER,
  SET_ALL_TRIGGER_ACTION
} from '../actionTypes';
import { getMaxDisplayNum } from '../../utils/criterialUtils';
import { updateSessionByObject, updateFilterValue } from '../../utils/triggerUtils';

const { WorkFlow } = Enums;
const { UpdateFields, UserInput, ActionValueType } = WorkFlow;
const {
  FILTERVALUE,
  FIELDID,
  FUNCTIONTYPE,
  DISTRIBUTIONVALUE,
  DISPLAYNUM
} = ActionValueType;

const initialTrigger = {
  triggerSessions: [],
  actionFilters: {},
};

const WorkFlowTrigger = (state = initialTrigger, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_TRIGGER:
      const triggerNumber = getMaxDisplayNum(state.triggerSessions, 'sessionNum');
      const newTrigger = {
        sessionNum: triggerNumber + 1,
        triggerValue: {
          triggerType: UpdateFields,
          objectKey: '',
        }
      };
      return {
        ...state,
        triggerSessions: [
          ...state.triggerSessions,
          newTrigger
        ],
        actionFilters: {
          ...state.actionFilters,
          [triggerNumber + 1]: []
        }
      };

    case REMOVE_TRIGGER:
      return {
        triggerSessions: state.triggerSessions.filter(trigger => trigger.sessionNum !== payload.sessionNum),
        actionFilters: _.omit(state.actionFilters, [payload.sessionNum])
      };

    case SET_TRIGGER_OBJECT_KEY:
      const { sessionNum, objectKey } = payload;
      updateSessionByObject(state.triggerSessions, sessionNum, objectKey);
      return {
        ...state,
        triggerSessions: updateSessionByObject(state.triggerSessions, sessionNum, objectKey),
      };

    case ADD_TRIGGER_ACTION:
      const selectedActions = state.actionFilters[payload.sessionNum];
      const actionNumber = getMaxDisplayNum(selectedActions, DISPLAYNUM);
      return {
        ...state,
        actionFilters: {
          ...state.actionFilters,
          [payload.sessionNum]: [
            ...selectedActions,
            {
              [DISPLAYNUM]: actionNumber + 1,
              [FIELDID]: '',
              [FUNCTIONTYPE]: UserInput,
              [FILTERVALUE]: '',
              [DISTRIBUTIONVALUE]: [],
            }
          ],
        }
      };

    case UPDATE_TRIGGER_ACTION_FILTER_VALUE:
      updateFilterValue(state.actionFilters[payload.sessionNum], payload.displayNum, payload.updateValue, payload.updateKey);
      return {
        ...state,
        actionFilters: {
          ...state.actionFilters,
          [payload.sessionNum]: updateFilterValue(state.actionFilters[payload.sessionNum], payload.displayNum, payload.updateValue, payload.updateKey),
        }
      };

    case REMOVE_SESSION_FILTER:
      return {
        ...state,
        actionFilters: {
          ...state.actionFilters,
          [payload.sessionNum]: state.actionFilters[payload.sessionNum].filter(filter => filter.displayNum !== payload.displayNum),
        }
      };

    case SET_ALL_TRIGGER_ACTION:
      const { sessionValue, filtersValue } = payload;
      return {
        triggerSessions: sessionValue,
        actionFilters: filtersValue,
      };

    case RESET_TRIGGER:
      return initialTrigger;

    default:
      return state;
  }
};

export default WorkFlowTrigger;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/reducers/trigger.js